<div class="task-pipeline scroll-window">
    <div class="row">
      <div class="col-12 header">
        <div class="col stage" *ngFor="let stage of stagesUniversity">
          {{ stage.name }}
        </div>
      </div>
    </div>
    <div class="row tasks-container">
      <div class="col-12 tasks" cdkDropListGroup>
        <div *ngFor="let stage of stagesUniversity; let i = index" class="stage-column my-col" cdkDropList [cdkDropListData]="stage.tasks" (cdkDropListDropped)="drop($event, i,stagesUniversity)">
          <div class="task-wrapper">
            <div class="task" *ngFor="let task of stage.tasks" cdkDrag [cdkDragData]="task"
                 [ngStyle]="{'grid-column-start': task.start, 'grid-column-end': task.end, 'background-color': task.color}">
                 <div class="task-content" (click)="openTaskDetails(task)">
                  <div class="icon" >
                   <mat-icon class="task-icon" *ngIf="task.validation">verified_user</mat-icon>
                    <!-- <i class="fas fa-award" class="task-icon" *ngIf="task.validation"></i>
                    <mat-icon class="task-icon" *ngIf="task.validation">info</mat-icon> -->
                </div>
                
                <!-- <app-premimum-content [config]="config" [data]="contents"></app-premimum-content> -->
  
                <app-smart-tooltip [limit]="20" [text]="task.name"></app-smart-tooltip>
                <!-- <span style="border: 1px solid gray;border-radius: 30px; background: rgba(17, 23, 29, 0.6);">
                  <span style="font-size: 11px; padding: 5px;"><i class="fas fa-crown" style="color: rgb(253, 188, 104); font-size: 14px;padding: 3px 5px;"></i>Premium</span>
                </span> -->
                
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row" *ngIf="false">
      <div class="col-12 timeline">
        <div class="time-segment" *ngFor="let time of timeline">
          {{ time }}
        </div>
      </div>
    </div>
  </div>
  
</div>

<mat-card style="max-width: 500px;">
  <button type="button" class="btn btn-primary my-2 btn-icon-text" (click)="goToEmbajadaRequisites()">
      <i class="fas fa-id-card me-2"></i> Requisitos Visado
    </button>

  <div>
    <a href="https://www.exteriores.gob.es/es/ServiciosAlCiudadano/Paginas/Servicios-consulares.aspx?scco=Costa+Rica&scd=252&scca=Visados&scs=Visados+Nacionales+-+Visado+de+estudios" target="_blank">Requisitos Visado</a>
    <a href="https://www.exteriores.gob.es/DocumentosAuxiliaresSC/Costa%20Rica/SAN%20JOS%c3%89%20DE%20COSTA%20RICA%20(E)/SOLICITUD%20CITA%20DE%20VISADO%20DE%20ESTUDIOS.pdf" target="_blank">Instrucciones para obtener la cita del visado</a>

    <a href="https://www.rree.go.cr/?sec=servicios&cat=autenticaciones&cont=734" target="_blank">Indicaciones Apostilla de Documentos</a>
  </div>

  <div class="d-flex">
    <h4>Notas: </h4>
    <ul>
      <li>1. De todos los documentos se deberá presentar 1 documento original y 1 copia. </li>
      <li>2. La solicitud del Visado de Estudiante ante la Embajada se puede iniciar con una antelación de 3 meses (no más) para el comienzo de las clases, y se presenta tras sacar cita en la web de la Embajada de España.</li>
      <li>3. Desde el 10 de Mayo de 2021 es obligatorio solicitar cita previa para realizar la apostilla de documentos en la Casa Amarilla. Los timbres para los documentos se pueden comprar en Casa Amarilla, en la misma oficina donde se presentan los documentos a apostillar.</li>
    </ul>
  </div>

</mat-card>


  
  
